import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";

class DimensionalTemplateDetail extends Component {
  state = {
    pageTitle: "Boyutsal Ölçüm Şablon Detay",
    pageTitleDetail: "Boyutsal Ölçüm Şablon Detay",
    pageAddLink: "boyutsal-olcum-sablon-ekle",
    pageListLink: "boyutsal-olcum-sablon-listele",
    breadcrumb: [{ text: "Boyutsal Ölçüm Şablon", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    measurement: "",
    documents: "",
    tolerance: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/dimensionalTemplates/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            measurement: response.data.measurement,
            documents: response.data.documents,
            tolerance: response.data.tolerance,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Dökümandaki Ref. Bölge</th>
                    <td colSpan="4">
                      {this.state.documents ? this.state.documents : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Gerek/Ölçü (cm)</th>
                    <td colSpan="4">{this.state.measurement}</td>
                  </tr>

                  <tr>
                    <th>Tolerans</th>
                    <td colSpan="4">
                      {this.state.tolerance ? this.state.tolerance : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default DimensionalTemplateDetail;
